import { ListItem } from "../styles/Styles";
import { INDEX_PROP } from "../types/Constants";
import type { EditableItem } from "../types/EditableItem";
import type { EditableListItemProps } from "../types/EditableListItemProps";
import { EditableListItemEdit } from "./EditableListItemEdit";
import { EditableListItemView } from "./EditableListItemView";

export const EditableListItem = <T extends EditableItem>(props: EditableListItemProps<T>) => {
    const { onChange, value, columns, canRemove, canEdit } = props;
    if (!value || !onChange || !columns) {
        return null;
    }

    const onChangeCallback = (changedItem: T) => {
        if (changedItem === null) {
            onChange(changedItem, value[INDEX_PROP]);
        } else {
            onChange(changedItem);
        }
    };

    return (
        <ListItem key={`${value.index}-ListItem`}>
            {value.isEditing && canEdit ? (
                <EditableListItemEdit<T> {...props} onChange={onChangeCallback} value={value} columns={columns} />
            ) : (
                <EditableListItemView<T> {...props} onChange={onChangeCallback} value={value} columns={columns} canRemove={canRemove} />
            )}
        </ListItem>
    );
};
